<script setup lang="ts">
import { computed } from '@vue/reactivity';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

const emit = defineEmits(['selected', 'selectedValue']);

const props = defineProps({
  decoration: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
});

const { websiteText } = useWebsiteTexts();

function selectPlacement(id: string, value: string) {
  emit('selected', id);
  emit('selectedValue', value);
}

const lowercaseName = computed(
  () => props.decoration.name?.toLowerCase() || ''
);
</script>

<template>
  <div
    :key="decoration.id"
    :class="['decoration-card', { 'decoration-card--selected': selected }]"
    @click="selectPlacement(decoration.id, decoration.value)"
  >
    <img
      class="decoration-card__image"
      :src="decoration.url"
      :alt="decoration.name"
    />
    <div class="decoration-card__name">
      {{ lowercaseName }}
    </div>
    <div
      v-if="
        decoration.landingPageLinkUrl !== undefined &&
        decoration.landingPageLinkUrl !== ''
      "
      class="decoration-card__landing-page-link"
    >
      <a :href="decoration.landingPageLinkUrl" target="_blank">
        {{ websiteText('decoration__print-example').value }}
      </a>
    </div>
    <div v-if="decoration.area" class="decoration-card__area">
      {{ decoration.area }}
    </div>
  </div>
</template>

<style>
.decoration-card {
  position: relative;
  cursor: pointer;
}

.decoration-card--selected::after {
  content: url('../../../static/icons/checkmark_white_icon.svg');
  height: 32px;
  width: 32px;
  background: var(--color-neutrals-100);
  top: -8px;
  right: -8px;
  position: absolute;
  display: grid;
  place-content: center;
  border-radius: 50%;
}

.decoration-card__image {
  border: 1px solid var(--color-neutrals-50);
  width: 100%;
  border-radius: 6px;
}

.decoration-card--selected .decoration-card__image {
  border: 1px solid var(--color-neutrals-100);
}

.decoration-card__landing-page-link {
  text-decoration: underline;
  color: var(--color-text-darker);
  line-height: 19px;
  font-size: 14px;
  margin-top: 4px;
}

.decoration-card__name {
  color: var(--color-text-darker);
  line-height: 19px;
  font-size: 14px;
  text-transform: capitalize;
}

.decoration-card--selected .decoration-card__name {
  font-weight: 700;
}

.decoration-card__area {
  color: var(--color-neutrals-80);
  line-height: 14px;
  font-size: 12px;
}

.decoration-card--selected .decoration-card__area {
  color: var(--color-text-darker);
}
</style>
